import React from 'react'
import TimelineItem from './TimelineItem'

const TimelineList = (props) => {
    return (
        <ul>
            {
                props.items.map((item, idx) =>
                    <TimelineItem
                        key={idx}
                        idx={idx}
                        title={item.year}
                        onClick={props.onItemClick}
                        selected={item.selected}
                        isFirst={props.isFirst}
                        isLast={props.isLast}
                    />
                )
            }
        </ul>
    )
}

export default TimelineList;


// WEBPACK FOOTER //
// ./src/components/TimelineList.jsx